/**
 * Only what the orchestrator's upload route accepts (iq-ai-cio
 * `file_manager._ALLOWED_CONTENT_TYPES`): it refuses `.doc`, `.json` and `.xml`
 * with a 400, so offering them only produced a chip whose file never reached the
 * chat. iq-ai-cio's `tests/api/test_files_upload_accept.py` vendors this list and
 * posts each extension to the real route, so change both together.
 */
export const ACCEPTED_FILE_TYPES = '.pdf,.docx,.xls,.xlsx,.pptx,.csv,.txt,.png,.jpg,.jpeg';

export const ACCEPTED_EXTENSIONS: readonly string[] = ACCEPTED_FILE_TYPES.split(',').map((type) =>
  type.replace(/^\./, ''),
);

export const MAX_ATTACHMENTS = 10;

export const MAX_ATTACHMENT_BYTES = 20 * 1024 * 1024;

export const UPLOAD_CONCURRENCY = 3;
